import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { selectWarehouseData } from "../../redux/slices/warehouseSlice";
import { toast } from "react-toastify";
import { getProtected } from "../../network/ApiService";
import { API_END_POINTS } from "../../network/apiEndPoint";
import { useNavigate  , useParams} from "react-router-dom";
import HeroSection from "../HeroSection/HeroSection";


const ViewWarehouse = (props) => {
  const { id } = props;
  const [selectedWarehouse, setSelectedWarehouse] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const { allWarehouses } = useSelector(selectWarehouseData);
  const { t } = useTranslation();
  const navigate = useNavigate() ; 
  const params = useParams() ; 
  const getWarehouseById = async (id) => {
    
    try {
      const url = `${API_END_POINTS.warehouses}${id}/`;
      const response = await getProtected(url);
      if (response) {
        // setSelectedWarehouse(response); 
        console.log("response = " , response)  ; 
        return response;
      }
    } catch (err) {
      throw err;
    }
  };

  useEffect(() => {
   ;(async () => {
    const warehouseID = params.id;
    if (warehouseID) {
      setShowModal(true);
      try {
        const response = await getWarehouseById(warehouseID);
        if (response) {
          console.log("response = ", response);
          setSelectedWarehouse([response]);
        }
      } catch (err) {
        console.log("error => ", err);
      }
    } else {
      toast.error(t("warehouse.view.error"));
      // setViewWarehouseId(null);
    }
   })()
  }, [id, allWarehouses, t]);

  const formatKey = (key) => {
    // Try to get translation first
    const translationKey = `warehouse.view.fields.${key.toLowerCase()}`;
    const translation = t(translationKey);
    
    // If no translation found, format the key as before
    if (translation === translationKey) {
      return key
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());
    }
    
    return translation;
  };

  const closeModal = () => {
    setShowModal(false);
    navigate('/dashboard') ; 
  };


  if (!showModal) return null;

  return (
    <div className={`z-[1000] flex items-center justify-center  ${showModal ? "block" : "hidden"}`}>
      <HeroSection t={t} showText = {false} />
  <div
    className="fixed-inset-0  bg-black bg-opacity-50 transition-opacity backdrop-blur-sm"
    onClick={closeModal}
  />
  
  {/* Modal */}
  <div className="relative bg-white z-[1000] rounded-lg shadow-xl w-full max-w-5xl mx-auto max-h-[95vh] overflow-y-auto">
    {/* Header */}
    <div className="sticky top-0 flex items-center justify-between p-4 md:p-5 border-b border-gray-200 bg-white z-10 rounded-t-lg">
      <div className="flex items-center space-x-3">
        <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
          <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
          </svg>
        </div>
        <h2 className="text-lg md:text-xl font-semibold text-gray-800">
          {t("warehouse.view.title")}
        </h2>
      </div>
      <button
        className="p-2 ml-auto bg-transparent text-gray-400 hover:text-gray-600 rounded-full hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-300"
        onClick={closeModal}
        aria-label="Close"
      >
        <FaTimes className="w-4 h-4 md:w-5 md:h-5" />
      </button>
    </div>
    
    {/* Body */}
    {selectedWarehouse && selectedWarehouse?.length > 0 ? (
      <div className="p-4 md:p-6">
        {selectedWarehouse.map((warehouse, index) => (
          <div
            key={warehouse?.id || index}
            className="mb-6 last:mb-0 bg-gradient-to-br from-white to-gray-50 rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-all duration-200"
          >
            {/* Warehouse Header */}
            {/* <div className="bg-blue-50 border-b border-blue-100 p-4 rounded-t-lg">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center text-white font-bold text-lg">
                    {warehouse?.name?.charAt(0)?.toUpperCase() || 'W'}
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">{warehouse?.name}</h3>
                    <p className="text-sm text-blue-600 font-mono">ID: {warehouse?.id}</p>
                  </div>
                </div>
                <div className="text-right">
                  <div className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    Active
                  </div>
                </div>
              </div>
            </div> */}

            {/* Warehouse Details */}
            <div className="p-4">
              {/* Basic Information Section */}
              <div className="mb-6">
                <h4 className="text-sm font-semibold text-gray-700 mb-3 flex items-center">
                  <svg className="w-4 h-4 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  {t("warehouse.table.basicInformation")}
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  <div className="bg-white p-3 rounded-md border border-gray-100">
                    <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">{t("warehouse.table.capacity")}</p>
                    <p className="text-lg font-semibold text-gray-900">{warehouse?.capacity?.toLocaleString()}</p>
                    <p className="text-xs text-gray-500">{t("warehouse.table.units")}</p>
                  </div>
                  
                  <div className="bg-white p-3 rounded-md border border-gray-100">
                    <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">{t("warehouse.table.manager")}</p>
                    <p className="text-sm font-medium text-gray-900">
                      {warehouse?.manager ? (
                        <span className="flex items-center">
                          <div className="w-6 h-6 bg-gray-300 rounded-full flex items-center justify-center text-xs font-bold text-gray-600 mr-2">
                            {warehouse?.manager?.charAt(0)?.toUpperCase()}
                          </div>
                          {warehouse?.manager}
                        </span>
                      ) : (
                        <span className="text-gray-400 italic">{t("warehouse.table.notAssigned")}</span>
                      )}
                    </p>
                  </div>

                  <div className="bg-white p-3 rounded-md border border-gray-100">
                    <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">{t("warehouse.table.status")}</p>
                    <div className="flex items-center">
                      <div className="w-2 h-2 bg-green-400 rounded-full mr-2"></div>
                      <span className="text-sm font-medium text-green-700">{t("warehouse.table.operational")}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Address Information Section */}
              <div className="mb-6">
                <h4 className="text-sm font-semibold text-gray-700 mb-3 flex items-center">
                  <svg className="w-4 h-4 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  {t("warehouse.table.locationDetails")}
                </h4>
                <div className="bg-white p-4 rounded-md border border-gray-100">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                    <div>
                      <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">{t("warehouse.table.street")}</p>
                      <p className="text-sm text-gray-900">
                        {warehouse?.warehouse_street || <span className="text-gray-400 italic">{t("warehouse.table.notSpecified")}</span>}
                      </p>
                    </div>
                    
                    <div>
                      <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">{t("warehouse.table.city")}</p>
                      <p className="text-sm text-gray-900">
                        {warehouse?.warehouse_city || <span className="text-gray-400 italic">{t("warehouse.table.notSpecified")}</span>}
                      </p>
                    </div>
                    
                    <div>
                      <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">{t("warehouse.table.zipCode")}</p>
                      <p className="text-sm text-gray-900 font-mono">
                        {warehouse?.warehouse_zip || <span className="text-gray-400 italic">{t("warehouse.table.notSpecified")}</span>}
                      </p>
                    </div>
                    
                    <div>
                      <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">{t("warehouse.table.country")}</p>
                      <p className="text-sm text-gray-900">
                        {warehouse?.warehouse_country || <span className="text-gray-400 italic">{t("warehouse.table.notSpecified")}</span>}
                      </p>
                    </div>
                  </div>
                  
                  {/* Full Address Display */}
                  <div className="mt-4 pt-4 border-t border-gray-100">
                    <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">{t("warehouse.table.fullAddress")}</p>
                    <div className="flex items-start space-x-2">
                      <svg className="w-4 h-4 text-gray-400 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                      <p className="text-sm text-gray-700 leading-relaxed">
                        {[
                          warehouse?.warehouse_street,
                          warehouse?.warehouse_city,
                          warehouse?.warehouse_zip,
                          warehouse?.warehouse_country
                        ].filter(Boolean).join(', ') || 'Address information not available'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Description Section */}
              {warehouse?.description && (
                <div className="mb-4">
                  <h4 className="text-sm font-semibold text-gray-700 mb-3 flex items-center">
                    <svg className="w-4 h-4 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    {t("warehouse.table.description")}
                  </h4>
                  <div className="bg-white p-4 rounded-md border border-gray-100">
                    <p className="text-sm text-gray-700 leading-relaxed">{warehouse?.description}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    ) : (
      <div className="text-center text-gray-600 bg-gray-50 p-8 rounded-md m-4 md:m-6">
        <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
          </svg>
        </div>
        <p className="text-lg font-medium text-gray-900 mb-2">{t("warehouse.table.noWareshouseData")}</p>
        <p className="text-sm text-gray-500">{t("warehouse.table.noWarehouseInfo")}</p>
      </div>
    )}
  </div>
</div>
  );
};

export default ViewWarehouse;